import {Pipe, PipeTransform} from '@angular/core';

export enum TFilterOpera {foOperaField, foOperaIqual, foOperaInves, foOperaMenor, foOperaMaior}

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'filterValue',
    pure: false
})
export class FilterValuePipe implements PipeTransform {

    constructor() {


    }

    transform(items: any[], value: any, opera: TFilterOpera = TFilterOpera.foOperaIqual): any[] {

        if (!items) return [];

        if (opera == TFilterOpera.foOperaIqual) return items.filter(item => (item == value));
        if (opera == TFilterOpera.foOperaInves) return items.filter(item => (item != value));
        if (opera == TFilterOpera.foOperaMenor) return items.filter(item => (item <= value));
        if (opera == TFilterOpera.foOperaMaior) return items.filter(item => (item >= value));

        return items;

    }

}



// WEBPACK FOOTER //
// ./src/pipes/filter-value/filter-value.ts